export type ContentCopyState =
  | 'emptyColumns'
  | 'emptyRows'
  | 'articleBack'
  | 'articleNoData'
  | 'notBound'
  | 'unavailable';

const CONTENT_COPY: Record<'de' | 'en', Record<ContentCopyState, string>> = {
  de: {
    articleBack: 'Zurueck',
    articleNoData: 'Keine Artikeldaten verbunden.',
    emptyColumns: 'Keine Spalten in der verbundenen Datenquelle.',
    emptyRows: 'Keine Eintraege in der verbundenen Datenquelle.',
    notBound:
      'Noch nicht mit Inhalten der App verbunden. Nutze den Standard-Aufbau oder verbinde im Inspector eine Tabelle der App.',
    unavailable: 'Keine Inhalte verfuegbar.',
  },
  en: {
    articleBack: 'Back',
    articleNoData: 'No article data bound.',
    emptyColumns: 'No columns in the connected data source.',
    emptyRows: 'No entries in the connected data source.',
    notBound:
      'Not connected to App content yet. Use the standard structure or connect an App table in the inspector.',
    unavailable: 'No content available.',
  },
};

export function getContentCopy(
  locale: string | null | undefined,
  state: ContentCopyState
): string {
  const language = locale?.toLowerCase().startsWith('de') ? 'de' : 'en';
  return CONTENT_COPY[language][state];
}
